import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/startAPetition/pageContext';

export const StartAPetitionErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	/** Possible to implement custom view based on error instead of throwing */
	throw new Error(`Failed to retrieve data for StartAPetition page (error: ${error})`);
};
